export const ESC = 27;
export const DEFAULT_TIMEOUT = 500;
